<template>
  <div id="personalityPage" class="loading container">
    <div class="wrapper" id="loadingAnimation">
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="shadow"></div>
      <div class="shadow"></div>
      <div class="shadow"></div>
    </div>
    <div id="personality" style="visibility:hidden">
      <p class="padding-1">
        <span class="is-color-grey font-size-1-25">Your personality is</span>
        <br />
        <span
          class="is-color-pff-light-blue is-italic has-text-weight-bold personalityText is-font-sans"
          >{{ yourPersonality }}</span
        >
      </p>
      <img
        :src="yourPersonalityImage"
        :alt="yourPersonality"
        class="padding-image image-width-20"
      />
      <p class="padding-sides-bottom-2 is-color-grey font-size-1-25">
        {{ aboutYourPersonality }}
      </p>
      <h1
        class="is-color-pff-green howText has-text-weight-bold"
        v-if="howToHelp"
      >
        How you can make an impact:
      </h1>
      <p
        class="is-color-grey font-size-1-25 padding-sides-bottom-2"
        v-if="howToHelp"
        v-html="howToHelp"
      ></p>
      <br />
      <br />
      <button
        class="button is-font-sans is-color-white is-background-color-pff-orange font-size-1-25"
        v-on:click="openModal"
      >
        EMAIL MY RESULTS
      </button>
      <br />
      <br />
      <br />
      <div class="modal" id="shareModal">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p
              class="modal-card-title has-text-weight-bold is-font-sans is-color-pff-light-blue"
            >
              Email my result
            </p>
            <button
              class="delete"
              aria-label="close"
              v-on:click="closeModal"
            ></button>
          </header>
          <form @submit.prevent="shareResult">
            <section class="modal-card-body">
              <div class="field">
                <label class="label has-text-left is-color-grey"
                  >First Name</label
                >
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="shareFirstName"
                    placeholder="Enter your first name"
                    required
                  />
                </div>
              </div>
              <div class="field">
                <label class="label is-color-grey has-text-left"
                  >Last Name</label
                >
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="shareLastName"
                    placeholder="Enter your last name"
                    required
                  />
                </div>
              </div>
              <div class="field">
                <label class="label has-text-left is-color-grey">Email</label>
                <div class="control">
                  <input
                    class="input"
                    type="email"
                    v-model="shareEmail"
                    placeholder="Enter your email address"
                    required
                  />
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <a
                class="button is-font-sans is-color-pff-orange"
                v-on:click="closeModal"
                >CANCEL</a
              >
              <button
                class="button is-font-sans is-color-white is-background-color-pff-orange"
                id="shareResultButton"
              >
                SEND
              </button>
            </footer>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import confetti from "canvas-confetti";
import { db } from "../components/firebase.init";
import { setTimeout } from "timers";

export default {
  name: "Personality",
  data() {
    return {
      yourPersonality: "",
      yourPersonalityImage: "",
      aboutYourPersonality: "",
      howToHelp: "",
      yourPersonalityId: "",
      results: this.$store.getters.getResult,
      allPersonalities: this.$store.getters.getPersonalities,
      grading: [],
      shareEmail: "",
      shareFirstName: "",
      shareLastName: ""
    };
  },

  methods: {
    saveResult() {
      db.collection("results")
        .add({
          time: new Date(Date.now()),
          personalityId: this.yourPersonalityId,
          personalityTye: this.yourPersonality
        })
        .then(confirmation => {
          console.log("Result saved.");
        })
        .catch(error => {
          alert(error);
          console.log(error);
        });
    },

    openModal() {
      document.getElementById("shareModal").classList.add("is-active");
    },
    closeModal() {
      document.getElementById("shareModal").classList.remove("is-active");
    },

    shareResult() {
      document
        .getElementById("shareResultButton")
        .setAttribute("disabled", true);
      db.collection("shareResults")
        .add({
          email: this.shareEmail.toLowerCase(),
          firstName: this.shareFirstName,
          lastName: this.shareLastName,
          personality: this.yourPersonality,
          aboutThePersonality: this.aboutYourPersonality,
          personalityImage: this.yourPersonalityImage,
          howToHelp: this.howToHelp,
          personalityId: this.yourPersonalityId,
          time: new Date(Date.now())
        })
        .then(confirmation => {
          this.shareEmail = "";
          document
            .getElementById("shareResultButton")
            .removeAttribute("disabled", true);
          document.getElementById("shareModal").classList.remove("is-active");
        })
        .catch(error => {
          alert(error);
          console.log(error);
          document
            .getElementById("shareResultButton")
            .removeAttribute("disabled", true);
          document.getElementById("shareModal").classList.remove("is-active");
        });
    }
  },

  beforeMount() {
    if (this.results.length > 0) {
      this.results.forEach(resultSet => {
        if (this.grading.find(x => x.id == resultSet.personality)) {
          this.grading.find(x => x.id == resultSet.personality).count++;
        } else {
          const data = {
            id: resultSet.personality,
            count: 1
          };
          this.grading.push(data);
        }
      });

      let desiredCount = Math.round(this.results.length / 2);

      console.log("Desired count = " + desiredCount);
      console.log(this.grading);

      if (this.grading.length < 5) {
        if (this.grading.length == 4) {
          var personalityResult = this.allPersonalities.find(
            x => x.personalityId == this.grading.find(x => x.count == 2).id
          );

          this.yourPersonality = personalityResult.personalityType;
          this.yourPersonalityImage = personalityResult.personalityImage;
          this.aboutYourPersonality = personalityResult.personalityDescription;
          this.yourPersonalityId = personalityResult.personalityId;
          this.howToHelp = personalityResult.personalityWaysToHelp;

          this.saveResult();
        } else if (this.grading.length == 3) {
          if (this.grading.find(x => x.count == 3)) {
            var personalityResult = this.allPersonalities.find(
              x => x.personalityId == this.grading.find(x => x.count == 3).id
            );

            this.yourPersonality = personalityResult.personalityType;
            this.yourPersonalityImage = personalityResult.personalityImage;
            this.aboutYourPersonality =
              personalityResult.personalityDescription;
            this.yourPersonalityId = personalityResult.personalityId;
            this.howToHelp = personalityResult.personalityWaysToHelp;

            this.saveResult();
          } else {
            var personalityResult = this.allPersonalities.find(
              x =>
                x.personalityId == this.$store.getters.getUniversalPersonality
            );

            this.yourPersonality = personalityResult.personalityType;
            this.yourPersonalityImage = personalityResult.personalityImage;
            this.aboutYourPersonality =
              personalityResult.personalityDescription;
            this.yourPersonalityId = personalityResult.personalityId;
            this.howToHelp = personalityResult.personalityWaysToHelp;

            this.saveResult();
          }
        } else if (this.grading.length == 2) {
          var personalityResult = this.allPersonalities.find(
            x => x.personalityId == this.grading.find(x => x.count >= 3).id
          );

          this.yourPersonality = personalityResult.personalityType;
          this.yourPersonalityImage = personalityResult.personalityImage;
          this.aboutYourPersonality = personalityResult.personalityDescription;
          this.yourPersonalityId = personalityResult.personalityId;
          this.howToHelp = personalityResult.personalityWaysToHelp;

          this.saveResult();
        } else {
          var personalityResult = this.allPersonalities.find(
            x => x.personalityId == this.grading[0].id
          );

          this.yourPersonality = personalityResult.personalityType;
          this.yourPersonalityImage = personalityResult.personalityImage;
          this.aboutYourPersonality = personalityResult.personalityDescription;
          this.yourPersonalityId = personalityResult.personalityId;
          this.howToHelp = personalityResult.personalityWaysToHelp;

          this.saveResult();
        }
      } else {
        var personalityResult = this.allPersonalities.find(
          x => x.personalityId == this.$store.getters.getUniversalPersonality
        );

        this.yourPersonality = personalityResult.personalityType;
        this.yourPersonalityImage = personalityResult.personalityImage;
        this.aboutYourPersonality = personalityResult.personalityDescription;
        this.yourPersonalityId = personalityResult.personalityId;
        this.howToHelp = personalityResult.personalityWaysToHelp;

        this.saveResult();
      }

      // this.grading.forEach(element => {
      //   if (element.count == desiredCount || element.count > desiredCount) {
      //     var personalityResult = this.allPersonalities.find(
      //       x => x.personalityId == element.id
      //     );

      //     this.yourPersonality = personalityResult.personalityType;
      //     this.yourPersonalityImage = personalityResult.personalityImage;
      //     this.aboutYourPersonality = personalityResult.personalityDescription;
      //     this.yourPersonalityId = personalityResult.personalityId;
      //     this.howToHelp = personalityResult.personalityWaysToHelp;

      //     this.saveResult();
      //   } else {
      //     var personalityResult = this.allPersonalities.find(
      //       x => x.personalityId == this.$store.getters.getUniversalPersonality
      //     );

      //     this.yourPersonality = personalityResult.personalityType;
      //     this.yourPersonalityImage = personalityResult.personalityImage;
      //     this.aboutYourPersonality = personalityResult.personalityDescription;
      //     this.yourPersonalityId = personalityResult.personalityId;
      //     this.howToHelp = personalityResult.personalityWaysToHelp;

      //     this.saveResult();
      //   }
      // });

      setTimeout(function() {
        document.getElementById("personalityPage").classList.remove("loading");
        document.getElementById("personalityPage").classList.add("personality");
        document.getElementById("loadingAnimation").style.visibility = "hidden";
        document.getElementById("personality").style.visibility = "visible";
        confetti();
      }, 1500);
    } else {
      this.$router.push("/");
    }
  },
  mounted() {
    if (this.results.length < 0) {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
strong {
  color: #00a2ab !important;
}

/* .padding-1 {
  padding: 1rem;
} */

.howText {
  font-size: 1.75rem;
  padding-bottom: 0.75rem;
}

.personalityText {
  font-size: 2rem;
}

.loading {
  text-align: center;
  padding-top: 30vh;
  padding-left: 42vw;
}

.personality {
  text-align: center;
  /* padding-top: 0vh; */
}

.padding-image {
  padding: 0rem 2rem 2rem 2rem;
}

.padding-sides-bottom-2 {
  padding: 0rem 2rem 2rem 2rem;
}

.image-width-20 {
  width: 30rem;
}

@media only screen and (max-width: 600px) {
  .loading {
    text-align: center;
    padding-top: 30vh;
    padding-left: 50vw;
  }
}
</style>
